<template>
    <LayoutBase>
        <header id="header" class="justify-left">
            <div class="container">
                <!-- <a @click.prevent="uppyFileUpload.getPlugin('Dashboard').openModal();" ref="btn" class="avatar avatar--large" v-if="person">
                    <img :src="person.avatar" width="90" class="circle border border-white" v-if="person && person.avatar">
                    <span class="initials circle border border-white" v-if="person && !person.avatar">{{ person.initials }}</span>
                </a> -->
                
                <a @click.prevent="openModal('profile-media-library')" ref="btn" class="avatar avatar--large" v-if="person">
                    <img :src="person.avatar" width="90" height="90" class="circle border border-white" v-if="person && person.avatar">
                    <span class="initials circle border border-white" v-if="person && !person.avatar">{{ person.initials }}</span>
                </a>

                <media-library
                    name="profile-media-library"
                    :opened="modalOpened"
                    @closedModal="onClosedModal"
                    :group="group"
                    :avatar=true
                    :avatar_id="person.id"
                    v-model="files"
                    v-if="person" />

                <div class="">
                    <h1 class="h1">{{ person.name }}</h1>
                    <div class="contact-details">
                        <p>{{ person.job_title }}</p>

                        <p v-if="person.phone_office">
                            <span>Phone:</span>
                            <a :href="'tel:' + person.phone_office">{{ person.phone_office }}</a>
                        </p>

                        <p v-if="person.phone_mobile">
                            <span>Mobile:</span>
                            <a :href="'tel:' + person.phone_mobile">{{ person.phone_mobile }}</a>
                        </p>

                        <p v-if="person.email && team.hide_email === 0">
                            <span>Email:</span>
                            <a :href="'mailto:' + person.email">{{ person.email }}</a>
                        </p>

                    </div>
                </div>
                <div class="actions">          
                    <router-link class="btn btn-small" :to="{ name: 'edit-profile'}" v-if="loggedInUser.id == person.id || isAdmin">Edit profile</router-link>
                </div>
            </div>
            <nav class="container">
                <!-- <ul>
                    <li>
                        <a href="#">Posts</a>
                    </li>
                    <li>
                        <a href="#">Groups</a>
                    </li>
                </ul> -->
            </nav>
        </header>

        <div class="container profile">

            <div class="panel">
                <div class="grid">
                    <div class="col-md-8">
                        <div class="profile__item">
                            <span class="h4">Intro</span> 
                            <div v-html="introFormatted" v-if="person.intro"></div>
                        </div>
                        <div class="profile__item">
                            <span class="h4">Experience</span>
                            <div v-html="experienceFormatted" v-if="person.work_experience"></div>
                        </div>
                    </div>

                    <div class="col-4">
                    </div>
                </div>
            </div>

        </div>
    </LayoutBase>
</template>

<script>
    import LayoutBase from '../../layouts/LayoutBase';
    import { mapState, mapGetters } from 'vuex';

    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                editing: null,
                showEditButton: null,
                person: {},
                files: [],
                modalOpened: false,
                isAdmin: window.user_can.admin,
            }
        },
        computed: {
            introFormatted: function () {
                return '<p>' + this.person.intro.replace(/\n([ \t]*\n)+/g, '</p><p>')
                 .replace('\n', '<br />') + '</p>';
            },
            experienceFormatted: function () {
                return '<p>' + this.person.work_experience.replace(/\n([ \t]*\n)+/g, '</p><p>')
                 .replace('\n', '<br />') + '</p>';
            },
            ...mapState({
                loggedInUser: state => state.auth.user,
                team: state => state.auth.team
            }),
        },
        created() {
            this.getUser();
        },
        mounted() {
        
        },
        methods: {
            onClosedModal(){
                this.modalOpened = false;
                MicroModal.close('profile-media-library')
            },
            openModal(modal){
                this.modalOpened = true;
                MicroModal.show(modal);
            },
            getUser() {
                axios.get('/api/user/' + this.$route.params.user).then((response) => {
                    this.person = response.data;

                    if(this.loggedInUser.id === this.person.id){
                        this.$store.commit('auth/setUser', response.data);
                    }
                    
                    // this.userReady();
                }, (response) => {
                    this.error = response;
                });
            },
            saveUser(){
                axios.put('/api/user/' + this.$route.params.user, this.person).then((response) => {
                    this.person = response.data;

                    if(this.loggedInUser.id === this.person.id){
                        this.$store.commit('auth/setUser', response.data);
                    }
                }, (response) => {
                    this.error = response;
                });
            }
        },
        watch: {
            files(files) {
                console.log("files changed");
                let token = document.head.querySelector('meta[name="csrf-token"]');
                if(typeof files[0] !== 'undefined' && token){
                    let img = files[0].url ?? files[0].urls.raw + "&q=80&w=180&h=180&fit=crop&crop=faces";
                    this.person.avatar = img;
                    this.saveUser(true);
                }
            }
        }
    }
</script>